import React from 'react';

import CartItemRow from './CartItemRow';

export default function CartItemsBody(props) {
  let {shoppingCart = {}} = props;
  let {cartItems = []} = shoppingCart;

  if (!cartItems[0])
    return null;

  return <div>
    {cartItems.map((item,index) =>
      <CartItemRow key={item.id} {...props} item={item} index={index}/>)}
  </div>;

}
